var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "gh-card gh-card--design",
      class: {
        "gh-card--collapsed": _vm.collapsed,
        "gh-card--design-assist": _vm.isKeyVisualAssist,
      },
    },
    [
      _vm._t("context-head"),
      _vm._v(" "),
      _c("div", { staticClass: "gh-card-design__row" }, [
        _c(
          "button",
          {
            staticClass: "gh-card__chevron",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-collapse")
              },
            },
          },
          [
            _c("i", {
              class: _vm.collapsed ? "fa fa-chevron-up" : "fa fa-chevron-down",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gh-card-design__image" }, [
          _vm.card.output.url
            ? _c("img", {
                ref: "cardImage",
                staticClass: "gh-card__image",
                class: { "gh-dnd-source": _vm.canDrag },
                attrs: {
                  src: _vm.card.output.url,
                  alt: "",
                  draggable: _vm.canDrag,
                },
                on: { dragstart: _vm.onImageDragStart, dragend: _vm.onDragEnd },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gh-card-design__prompt-col" },
          [
            _c(
              "GenerationHistoryCardSlide",
              { attrs: { expanded: !_vm.collapsed } },
              [
                _c(
                  "div",
                  { staticClass: "gh-card-design__prompt" },
                  [
                    _vm.isKeyVisualAssist
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "gh-card-text__meta gh-card-text__meta--in-design",
                            },
                            [
                              _c("GenerationHistoryMetaRows", {
                                attrs: {
                                  fields: _vm.assistMetaFields,
                                  variant: "detail",
                                  "prompt-tooltip": true,
                                  "can-drag-fields": _vm.canDrag,
                                  "row-key-prefix": `design-assist-${_vm.card.item_id}`,
                                },
                                on: {
                                  "field-drag-start": _vm.onAssistMetaDragStart,
                                  "field-drag-end": _vm.onDragEnd,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "gh-card-design__prompt-top" },
                            [
                              _c(
                                "span",
                                { staticClass: "gh-card-design__field-label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("generation_history.meta.prompt")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "gh-card-design__field-value gh-card-design__field-value--prompt",
                                  class: {
                                    "gh-dnd-source":
                                      _vm.canDrag && _vm.promptText,
                                  },
                                  attrs: {
                                    draggable: _vm.canDrag && !!_vm.promptText,
                                  },
                                  on: {
                                    dragstart: _vm.onPromptDragStart,
                                    dragend: _vm.onDragEnd,
                                  },
                                },
                                [
                                  _c("GenerationHistoryPromptPopover", {
                                    attrs: {
                                      text: _vm.card.input_meta.prompt,
                                      tooltip: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "gh-card-design__prompt-bottom" },
                            [
                              _c(
                                "span",
                                { staticClass: "gh-card-design__field-label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("generation_history.meta.ai_model")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "gh-card-design__field-value" },
                                [_vm._v(_vm._s(_vm.aiModelLabel))]
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gh-card-design__actions-col" },
          [
            _c("GenerationHistoryDesignCardActions", {
              attrs: {
                "is-favorite": _vm.card.is_favorite,
                "is-image-copied": _vm.isImageCopied,
                "is-prompt-copied": _vm.isPromptCopied || _vm.localPromptCopied,
              },
              on: {
                "copy-image": function ($event) {
                  return _vm.$emit("copy-image", _vm.$refs.cardImage)
                },
                "copy-prompt": _vm.onCopyPromptClick,
                download: function ($event) {
                  return _vm.$emit("download")
                },
                favorite: function ($event) {
                  return _vm.$emit("favorite")
                },
              },
            }),
            _vm._v(" "),
            _c(
              "GenerationHistoryCardSlide",
              { attrs: { expanded: !_vm.collapsed } },
              [
                _c("div", { staticClass: "gh-card-design__size" }, [
                  _c("span", { staticClass: "gh-card-design__field-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("generation_history.meta.image_size"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "gh-card-design__field-value" }, [
                    _vm._v("(" + _vm._s(_vm.imageSizeLabel) + ")"),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }